// Role slug constants — mirror RoleEnum.php
export const ROLES = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    MARKET_AGENT: 'market_agent',
    MARKET_ADMIN: 'market_admin',
    FIELD_OFFICER: 'field_officer',
    CALL_CENTER: 'call_center',
    INFRA_ENUMERATOR: 'infra_enumerator',
    COMMERCIAL_LEAD: 'commercial_lead',
    COMMERCIAL_MANAGER: 'commercial_manager',
    MANAGER_ASSISTANT: 'manager_assistant',
    FINANCE_MANAGER: 'finance_manager',
};

export const MARKET_ROLES = [
    ROLES.MARKET_AGENT,
    ROLES.MARKET_ADMIN,
    ROLES.FIELD_OFFICER,
    ROLES.CALL_CENTER,
    ROLES.INFRA_ENUMERATOR,
];

export const COMMERCIAL_ROLES = [
    ROLES.COMMERCIAL_LEAD,
    ROLES.COMMERCIAL_MANAGER,
    ROLES.MANAGER_ASSISTANT,
];

export const ADMIN_ROLES = [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
];

export const FINANCE_ROLES = [
    ROLES.FINANCE_MANAGER,
];

export const OPS_ROLES = [
    ROLES.SUPER_ADMIN,
    ROLES.ADMIN,
    ROLES.COMMERCIAL_LEAD,
    ROLES.COMMERCIAL_MANAGER,
    ROLES.MANAGER_ASSISTANT,
];

export const allRoles = () => [
    {label: 'Super Admin', value: ROLES.SUPER_ADMIN},
    {label: 'Admin', value: ROLES.ADMIN},
    {label: 'Market Agent', value: ROLES.MARKET_AGENT},
    {label: 'Market Admin', value: ROLES.MARKET_ADMIN},
    {label: 'Field Officer', value: ROLES.FIELD_OFFICER},
    {label: 'Call Centre', value: ROLES.CALL_CENTER},
    {label: 'Infra Enumerator', value: ROLES.INFRA_ENUMERATOR},
    {label: 'Commercial Lead', value: ROLES.COMMERCIAL_LEAD},
    {label: 'Commercial Manager', value: ROLES.COMMERCIAL_MANAGER},
    {label: 'Manager Assistant', value: ROLES.MANAGER_ASSISTANT},
    {label: 'Finance Manager', value: ROLES.FINANCE_MANAGER},
];

export const hasAnyRole = (roleSlugs = [], user = null) => {
    const roles = user?.roles ?? [];
    return roles.some(role => roleSlugs.includes(role));
};

export const hasRole = (roleSlug, user = null) => {
    return user?.roles?.includes(roleSlug) ?? false;
};

export const hasAnyPermission = (permissions = [], user = null) => {
    const userPerms = user?.permissions ?? [];
    return userPerms.includes('*') || userPerms.some(p => permissions.includes(p));
};

export const hasPermission = (permission, user = null) => {
    return user?.permissions?.includes('*') || user?.permissions?.includes(permission) || false;
};
